import { email as emailValidator, messageDefaults, phone as phoneValidator } from '@ahmdigital/form-validation';
import { InferType, string, TestConfig } from 'yup';
import { PRODUCT_TYPE } from '@ahmdigital/constants';

import { refinePriceSchema as sharedRefinePriceSchema } from '../../../../features/refine-price/schema';
import { validateName } from '../../../buy/components/buy-form/utils/name-validation/name-validation';

const { required } = messageDefaults;

const optionalValidator = (name: string, validate: (value: string) => string | null): TestConfig => ({
  name,
  test(value, ctx) {
    if (!value) return true;
    const error = validate(String(value));
    return error ? ctx.createError({ message: error }) : true;
  },
});

const refinePriceSchema = sharedRefinePriceSchema.shape({
  email: string().notRequired().test(optionalValidator('email', emailValidator())),
  name: string()
    .notRequired()
    .test(optionalValidator('name', (value) => validateName(value, 'Given name'))),
  phone: string().notRequired().test(optionalValidator('phone', phoneValidator())),
  productType: string().required(required).default(PRODUCT_TYPE.EXTRAS),
});

// TODO: AP-1837 Bit of a hack here. Because we are using yup number validators, the exported type is typed as number, however, because we consume these via formik, they are always strings.
// the above ticket calls out potentially moving to zod, which has nicer ergonomics around doing this exact thing.
export type RefinePriceSchemaType = Omit<
  InferType<typeof refinePriceSchema>,
  'age' | 'partnerAge' | 'hospitalExcess'
> & {
  age: string;
  hospitalExcess?: string;
  partnerAge?: string | null;
};

export default refinePriceSchema;
